import { ShieldAlert } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useColors } from '../hooks/useColors'

export default function ForbiddenPage() {
  const colors = useColors()

  return (
    <div
      style={{
        minHeight: '60vh',
        display: 'grid',
        placeItems: 'center',
        padding: '24px',
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: 420 }}>
        <div
          style={{
            width: 64,
            height: 64,
            borderRadius: '999px',
            background: 'rgba(239,68,68,0.12)',
            display: 'grid',
            placeItems: 'center',
            margin: '0 auto 16px',
          }}
        >
          <ShieldAlert size={30} color="#EF4444" />
        </div>
        <h1 className="font-display" style={{ fontSize: 22, fontWeight: 700, color: colors.textPrimary, margin: 0 }}>
          Access restricted
        </h1>
        <p className="font-body" style={{ fontSize: 14, color: colors.textSecondary, marginTop: 8 }}>
          Your role doesn&apos;t have permission to view this page. If you believe this is a
          mistake, contact an owner to update your access.
        </p>
        <Link
          to="/"
          className="font-body"
          style={{
            display: 'inline-block',
            marginTop: 20,
            padding: '10px 20px',
            borderRadius: 10,
            background: colors.accent,
            color: colors.bgSidebar,
            fontWeight: 600,
            textDecoration: 'none',
            fontSize: 14,
          }}
        >
          Back to dashboard
        </Link>
      </div>
    </div>
  )
}
